export default "__VITE_ASSET__BkxZyAY8__"